import { TrackingIdentity } from '../../../services/analytics/model';

export class UserIdentityAppointmentEvent implements TrackingIdentity {
  public readonly role: string = 'TENANT';
  public readonly step: string = 'Appointment Scheduled';
  constructor(public readonly userId: string, public readonly target_city: string) {}
}
